import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Explicit per-tab store context sent on every request; backend validates it.
let activeStoreId = null;
export const setApiStore = (id) => { activeStoreId = id || null; };

api.interceptors.request.use((cfg) => {
  if (activeStoreId) cfg.headers["X-Store-Id"] = activeStoreId;
  return cfg;
});

// Drop late responses issued for a previously selected store.
const isStale = (cfg) => {
  const sent = cfg?.headers?.["X-Store-Id"];
  return !!sent && sent !== activeStoreId;
};
const never = () => new Promise(() => {});
api.interceptors.response.use(
  (r) => (isStale(r.config) ? never() : r),
  (e) => (isStale(e.config) ? never() : Promise.reject(e)),
);

export const currency = (n) => `R ${Number(n || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const qty = (n) => Number(n || 0).toLocaleString("en-ZA");
